import React, { useState, useContext, useReducer, useMemo } from 'react';
import { Route } from 'react-router-dom';
import PageHeader from 'components/PageHeader';
import { Segment, Header, Icon, Button } from 'semantic-ui-react';
import { GlobalContext } from 'globalContext';
import PageLoader from 'components/PageLoader';
import DiferencasForm from './DiferencasForm';
import SwitchRouter from 'components/SwitchRouter';
import Diferencas from './Diferencas';
import request from 'services/http';
import { useSubscription } from 'utils';
import { tap } from 'rxjs/operators';
import SaldosForm from './SaldosForm';
import Saldos from './Saldos';
import ReportsForm from './ReportsForm';
import Reports from './Reports';

// Valores Iniciais do formulario de Diferenças
const initialFormValues = {
    empresa: '',
    dataIni: '',
    dataFim: '',
    considerarNegativo: true,
};

const formReducer = (state, action) => {
    if ('reset' in action) return initialFormValues;
    if (!('payload' in action)) return state;
    return { ...state, ...action.payload }; //1
};

// Valores Iniciais do formulario Saldos
const initialFormValuesSaldos = {
    empresa: '',
    dataIni: '',
    dataFim: '',
};
const formReducerSaldos = (state, action) => {
    if ('reset' in action) return initialFormValuesSaldos;
    if (!('payload' in action)) return state;
    return { ...state, ...action.payload }; //2
};

// Valores Iniciais do formulario de Relatórios
const initialFormValuesReports = {
    empresa: '',
    dataIni: '',
    dataFim: '',
    tipo: '',
};

const formReducerReports = (state, action) => {
    if ('reset' in action) return initialFormValuesReports;
    if (!('payload' in action)) return state;
    return { ...state, ...action.payload }; //3
};

export default function ApuracaoCaixa({ match: { path }, history }) {
    const [globalState] = useContext(GlobalContext);
    const [moduleData, setModuleData] = useState({
        justificativas: null,
    });

    const [dados, setDados] = useState({
        turnos: null,
        funcionarios: null,
    }); // State referentes as diferenças

    const [dadosSaldos, setDadosSaldos] = useState({
        saldos: null,
        saldosUnicos: null,
    }); //State referente aos Saldos

    const [dadosReports, setDadosReports] = useState({
        reports: null,
    }); // State referente aos Relatórios

    const [formState, setFormState] = useState('diferencas'); // Change Menu--

    const [form, setForm] = useReducer(formReducer, initialFormValues); // Registrar Diferenças
    const [formSaldos, setFormSaldos] = useReducer(formReducerSaldos, initialFormValuesSaldos); // Visualizar Justificativas
    const [formReports, setFormReports] = useReducer(formReducerReports, initialFormValuesReports); // Visualizar Relatórios




    const moduleData$ = useMemo(
        () =>
            request({
                url: '/controladoria/apuracao-caixa/justificativas',
                method: 'GET',
            }).pipe(
                tap(({ response }) => setModuleData({ justificativas: response.justificativas })),
            ),
        [setModuleData],
    );

    useSubscription(moduleData$, !moduleData.justificativas);

    const withMenu = (Component, props) => (
        <div className="row flex-grow-1 mt-2">
            <div className="col d-flex flex-column">
                <div className="row mx-0">
                    <div className="col">
                        <Header as="h3">
                            <Icon.Group size="big">
                                <Icon name="tasks" className="primary-color" />
                            </Icon.Group>
                            <Header.Content className="primary-color">
                                Ações{' '}
                                <Header.Subheader className="secondary-color">
                                    <strong>Escolha a ação desejada</strong>
                                </Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                </div>
                <div className="row flex-grow-1 flex-column">
                    <div className="col d-flex align-items-center flex-column justify-content-center">
                        <Button
                            icon
                            style={{ maxWidth: 300, cursor: formState === 'diferencas' ? 'default' : 'pointer' }}
                            className="btn-primary mt-2"
                            color="blue"
                            onClick={() => setFormState('diferencas')}
                            size="small"
                            fluid
                            basic={formState === 'diferencas' ? true : false}
                        >
                            <Icon name="dollar sign" /> Diferença de caixa
                        </Button>
                        <Button
                            icon
                            style={{ maxWidth: 300, cursor: formState === 'saldos' ? 'default' : 'pointer' }}
                            className="btn-primary mt-2"
                            onClick={() => setFormState('saldos')}
                            color="blue"
                            size="small"
                            fluid
                            basic={formState === 'saldos' ? true : false}
                        >
                            <Icon name="file alternate outline" /> Saldos
                        </Button>

                        <Button
                            icon
                            style={{ maxWidth: 300, cursor: formState === 'relatorios' ? 'default' : 'pointer' }}
                            className="btn-primary mt-2"
                            onClick={() => setFormState('relatorios')}
                            color="blue"
                            size="small"
                            fluid
                            basic={formState === 'relatorios' ? true : false}
                        >
                            <Icon name="clipboard list" /> Relatórios
                        </Button>
                    </div>
                </div>
            </div>
            <Component {...props} />
        </div>
    );

    const { empresas } = globalState;

    //Começo Diferenças //

    const difFormDiferencasProps = { empresas: empresas ? empresas : [], form, setForm, setDados };

    const difDiferencasProps = {
        empresas: empresas ? empresas : [],
        dados,
        setDados,
        justificativas: moduleData.justificativas,
    };

    //Fim Diferenças //

    //Começo Saldos//
    const difFormJustificativasProps = {
        empresas: empresas ? empresas : [],
        formSaldos,
        setFormSaldos,
        setDadosSaldos,
    };

    const difJustificativasProps = {
        empresas: empresas ? empresas : [],
        dadosSaldos,
        setDadosSaldos,
    };
    //Fim Saldos//

    // Começo Relatórios//

    const difFormReportsProps = {
        empresas: empresas ? empresas : [],
        formReports,
        setFormReports,
        setDadosReports,
    };

    const difReportsProps = {
        empresas: empresas ? empresas : [],
        dadosReports,
        setDadosReports,
    };

    //Fim Relatórios//

    return (
        <PageLoader active={globalState.empresas === null}>
            <div id="apuracao-caixa" className="page-content">
                <PageHeader />

                <Segment className="subcontent py-0">
                    <SwitchRouter>
                        <>
                            {formState === 'diferencas' && (
                                <Route
                                    exact
                                    path={path}
                                    restricted="controladoria>listDifApurCaixa"
                                    render={(props) =>
                                        withMenu(DiferencasForm, {
                                            ...props,
                                            ...difFormDiferencasProps,
                                        })
                                    }
                                />
                            )}
                            {formState === 'saldos' && (
                                <Route
                                    exact
                                    path={path}
                                    restricted="controladoria>listDifApurCaixa"
                                    render={(props) =>
                                        withMenu(SaldosForm, {
                                            ...props,
                                            ...difFormJustificativasProps,
                                        })
                                    }
                                />
                            )}

                            {formState === 'relatorios' && (
                                <Route
                                    exact
                                    path={path}
                                    restricted="controladoria>listDifRelatorio"
                                    render={(props) =>
                                        withMenu(ReportsForm, { ...props, ...difFormReportsProps })
                                    }
                                />
                            )}

                            <Route
                                exact
                                path={`${path}/diferencas`}
                                restricted="controladoria>listDifApurCaixa"
                                render={(props) => (
                                    <Diferencas {...props} {...difDiferencasProps} />
                                )}
                            />

                            <Route
                                exact
                                path={`${path}/saldos`}
                                restricted="controladoria>listDifApurCaixa"
                                render={(props) => (
                                    <Saldos {...props} {...difJustificativasProps} />
                                )}
                            />

                            <Route
                                exact
                                path={`${path}/relatorios`}
                                restricted="controladoria>listDifRelatorio"
                                render={(props) => <Reports {...props} {...difReportsProps} />}
                            />
                        </>
                    </SwitchRouter>
                </Segment>
            </div>
        </PageLoader>
    );
}
